// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr {\n  margin: 0;\n}\n/*# sourceMappingURL=AuditLog.css.map */", "",{"version":3,"sources":["webpack://AuditLog.less","webpack://src/components/Administration/AuditLog/AuditLog.less"],"names":[],"mappings":"AAAA;EACE,SAAA;ACCF;AACA,uCAAuC","sourcesContent":["hr {\n  margin: 0;;\n}","hr {\n  margin: 0;\n}\n/*# sourceMappingURL=AuditLog.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
